import gql from 'graphql-tag';

export default gql`
	query ModalForgetPassword {
		modalForgetPassword @client {
			isOpen
		}
	}
`;
